import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { CsrWebApiService } from '../../../../csr-web-api.service';
import { CareerChallengeTeamDto } from '../../../../models';
import { CareerChallengeAdminStore } from '../shared/career-challenge-admin.store';

@Component({
  selector: 'app-career-challenge-teams-tab',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatProgressBarModule, MatSnackBarModule],
  templateUrl: './teams-tab.component.html',
  styleUrl: './tab-shared.scss'
})
export class CareerChallengeTeamsTabComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly api = inject(CsrWebApiService);
  private readonly store = inject(CareerChallengeAdminStore);
  private readonly snackBar = inject(MatSnackBar);

  loading = false;
  teams: CareerChallengeTeamDto[] = [];

  get id(): string {
    return this.route.parent?.snapshot.paramMap.get('id') ?? '';
  }

  ngOnInit(): void {
    void this.load();
  }

  async load(): Promise<void> {
    this.loading = true;
    try {
      await this.store.load(this.id);
      this.teams = await firstValueFrom(this.api.listAdminCareerChallengeTeams(this.id));
      if (!this.teams?.length && this.store.challenge()?.teams?.length) {
        this.teams = this.store.challenge()!.teams;
      }
    } catch {
      this.teams = this.store.challenge()?.teams ?? [];
      this.snackBar.open('Could not refresh teams list', 'Close', { duration: 3000 });
    } finally {
      this.loading = false;
    }
  }
}
